import { api } from '../../lib/api';

export const resetPassword = data => {
  return api({
    method: 'post',
    url: '/api/passwords',
    data,
  });
};
